"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "PercentGeneralHandler", {
    enumerable: true,
    get: function() {
        return PercentGeneralHandler;
    }
});
const _decimalgeneralhandler = require("../decimal/decimal.general.handler");
let PercentGeneralHandler = class PercentGeneralHandler extends _decimalgeneralhandler.DecimalGeneralHandler {
};
